import { Link } from 'react-router-dom';
import AdListImage from './AdListImage';
import Button from 'components/Button';
import { AdListing } from 'types/adListing';

interface AdListFlatItemProps {
  ilan: AdListing;
  detailLinkBase?: string;
  disableDetailLinks?: boolean;
  onToggleFavorite?: (id: string | number, e: React.MouseEvent) => void;
  displayFavorites?: boolean;
}

export default function AdListFlatItem({ ilan, detailLinkBase = '/ilan-detay', disableDetailLinks = false, onToggleFavorite, displayFavorites = true }: AdListFlatItemProps) {
  const isFavorite = ilan.isUserFavorite === true;
  const detailLink = detailLinkBase ? `${detailLinkBase}/${ilan.id}` : `/ilan-detay/${ilan.id}`;
  return (
    <div className="card mb-3 product-card sb-ad-list-flat-item">
      <div className="row g-0">
        {/* Image Section */}
        <div className="col-12 col-md-4 position-relative sb-ad-list-flat-item__image">
          <AdListImage
            ilan={ilan}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            detailLink={detailLink}
            disableDetailLinks={disableDetailLinks}
          />
          {displayFavorites && <Button
            type="button"
            className={`btn position-absolute end-0 top-0 m-2 p-1 rounded-circle shadow-sm favorite-btn ${isFavorite ? 'active' : ''}`}
            style={{ backgroundColor: 'var(--sb-bg)' }}
            onClick={onToggleFavorite ? (e) => onToggleFavorite(ilan.id, e) : undefined}
          >
            <i className={`${isFavorite ? 'fas' : 'far'} fa-heart text-${isFavorite ? 'danger' : 'primary'}`} style={{ fontSize: '16px' }} />
          </Button>}
        </div>

        {/* Content Section */}
        <div className="col-12 col-md-8 sb-ad-list-flat-item__content">
          <div className="card-body h-100 d-flex flex-column">
            {disableDetailLinks ? (
              <h5 className="card-title mb-2">{ilan.baslik}</h5>
            ) : (
              <Link to={detailLink} className="text-decoration-none">
                <h5 className="card-title mb-2">{ilan.baslik}</h5>
              </Link>
            )}

                        {ilan.rejectionReason ? (
                          <div className="alert alert-danger py-2 px-2 small mb-2" role="status">
                            <i className="fas fa-times-circle me-1" aria-hidden />
                            <strong>Red gerekçesi:</strong> {ilan.rejectionReason}
                          </div>
                        ) : null}

                        <p className="card-text text-muted small mb-3">
                            {ilan.aciklama.length > 150 ? `${ilan.aciklama.substring(0, 150)}...` : ilan.aciklama}
                        </p>

                        {/* Bilgisayar Özellikleri */}
                        {ilan.kategori === "Bilgisayar" && (
                            <div className="specs-container mb-3">
                                <div className="d-flex flex-wrap gap-2">
                                    {ilan.islemci && (
                                        <div className="spec-item">
                                            <div className="spec-icon me-2">
                                                <i className="fas fa-microchip text-primary"></i>
                                            </div>
                                            <small>{ilan.islemci}</small>
                                        </div>
                                    )}
                                    {ilan.ekranKarti && (
                                        <div className="spec-item">
                                            <div className="spec-icon me-2">
                                                <i className="fas fa-tv text-primary"></i>
                                            </div>
                                            <small>{ilan.ekranKarti}</small>
                                        </div>
                                    )}
                                    {ilan.ram && (
                                        <div className="spec-item">
                                            <div className="spec-icon me-2">
                                                <i className="fas fa-memory text-primary"></i>
                                            </div>
                                            <small>{ilan.ram}</small>
                                        </div>
                                    )}
                                    {ilan.ssd && (
                                        <div className="spec-item">
                                            <div className="spec-icon me-2">
                                                <i className="fas fa-solid fa-hdd text-primary"></i>
                                            </div>
                                            <small>SSD: {ilan.ssd}</small>
                                        </div>
                                    )}
                                    {ilan.hdd && (
                                        <div className="spec-item">
                                            <div className="spec-icon me-2">
                                                <i className="fas fa-hdd text-primary"></i>
                                            </div>
                                            <small>HDD: {ilan.hdd}</small>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

            {/* Footer with Location and Price */}
            <div className="d-flex justify-content-between align-items-center mt-auto">
              <small className="text-muted">
                <i className="fas fa-map-marker-alt me-1" />
                {ilan.konum}
              </small>
              <span className="h5 mb-0 text-primary fw-bold">{ilan.fiyat.toLocaleString('tr-TR')} ₺</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}